"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmDleteLink = exports.confirmDlete = void 0;
/* ========================================================================
    Module: Confirm delete
 ========================================================================== */
/**
 * 削除実行のアラートを表示する
 *
 * @returns {void}
 */
const confirmDlete = () => {
    const linkElements = document.querySelectorAll(".js-delete");
    if (linkElements.length <= 0) {
        return;
    }
    linkElements.forEach((linkElemet) => {
        linkElemet.addEventListener("click", (e) => {
            e.preventDefault();
            let message = "削除しますがよろしいでしょうか？";
            if (linkElemet.dataset.message) {
                message = linkElemet.dataset.message.replaceAll(/(?:<br>|\\n)/g, "\n");
            }
            if (window.confirm(message)) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = linkElemet.href;
                form.style.display = "none";
                form.innerHTML = `
          <input type="hidden" name="_token" value="${linkElemet.dataset.csrfToken}">
          <input type="hidden" name="_method" value="DELETE">
        `;
                document.body.append(form);
                form.submit();
            }
        });
    });
};
exports.confirmDlete = confirmDlete;
/**
 * 削除実行のアラートを表示する
 *
 * @returns {void}
 */
const confirmDleteLink = () => {
    const linkElements = document.querySelectorAll(".js-delete-link");
    if (linkElements.length <= 0) {
        return;
    }
    linkElements.forEach((linkElemet) => {
        linkElemet.addEventListener("click", (e) => {
            e.preventDefault();
            let message = "削除しますがよろしいでしょうか？";
            if (linkElemet.dataset.message) {
                message = linkElemet.dataset.message.replaceAll(/(?:<br>|\\n)/g, "\n");
            }
            if (window.confirm(message)) {
                location.href = linkElemet.href;
            }
        });
    });
};
exports.confirmDleteLink = confirmDleteLink;
